// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3efaef4d31ea57e1ba4811f1f9d3bb275ce85e58/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};